export const calculateTokensCost = (numTokens: number) => {
  const costPerToken = 0.0015 / 1000;
  return costPerToken * numTokens;
};
